import { addListener, createListenerMiddleware } from "@reduxjs/toolkit";

import type { AppDispatch, RootState } from "../@types";
import type { ExtraOptions } from "../http/types.http";

const listener = createListenerMiddleware({
  onError: console.error
});

const startAppListening = listener.startListening.withTypes<RootState, AppDispatch, ExtraOptions>();
const stopAppListening = listener.stopListening.withTypes<RootState, AppDispatch, ExtraOptions>();
const addAppListener = addListener.withTypes<RootState, AppDispatch, ExtraOptions>();
const clearAppListeners = listener.clearListeners;
const listenerMiddleware = listener.middleware;

export { addAppListener, clearAppListeners, listenerMiddleware, startAppListening, stopAppListening };
